import { Button, Col, Layout, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState } from "react";
import CONSTANTS from "constants/constants";
import "components/OurServices/style.css";
import prodRed from "assets/prodred.svg";
import streamLineDev from "assets/streamline_dev.svg";
import enhanceDesign from "assets/enhance_design.svg";
import vehicleTestingAnalytics from "assets/vehicle_testing_analytics.svg";
import testRideAnalytics from "assets/test_ride_analytics.svg";
import endLineTesting from "assets/end_line_testing.svg";
import ProdRedDemoVideo from "assets/videos/Prod_red.mp4";
import { CheckCircleFilled } from "@ant-design/icons";
import { WatchVideoIcon } from "common/icons";
import DemoVideoModal from "common/DemoVideoModal";

const ProdRed = () => {
  const [demoVideoModal, setDemoVideoModal] = useState(false);
  const { PROD_RED } = CONSTANTS;
  return (
    <Layout>
      <Content>
        {demoVideoModal && (
          <DemoVideoModal
            demoVideoModal={demoVideoModal}
            onChangeDemoVideo={(view) => setDemoVideoModal(view)}
            demoVideo={ProdRedDemoVideo}
          />
        )}
        <Row
          className="pr4 pl4 pb2 pt2 prodred-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={12}>
            <p className="prodred-section-header mt1">
              Prod<span className="prodred-special-text">Red</span>
            </p>
            <p className="prodred-section-text">{PROD_RED.PROD_RED_1}</p>
            <Button
              className="watch-button mt1"
              onClick={() => setDemoVideoModal(true)}
            >
              <WatchVideoIcon className="watch-button-icon" />
              <span className="ml1">Quick Tour</span>
            </Button>
          </Col>
          <Col lg={12} className="flex-center">
            <img src={prodRed} className="prodred-image" alt="prodred" />
          </Col>
        </Row>

        <Row
          className="prodred-section pr4 pl4 pb2 pt2 prodred-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <p className="prodred-section-header mt1">
              Streamline
              <span className="prodred-special-text"> EV Development</span>
            </p>
            <p className="prodred-section-text">{PROD_RED.STREAMLINE_DEV}</p>
          </Col>
          <Col
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
            className="flex-center"
          >
            <img
              src={streamLineDev}
              className="prodred-image"
              alt="streamline EV"
            />
          </Col>
        </Row>
        <Row
          className="pr4 pl4 pb2 pt2 prodred-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={12}>
            <p className="prodred-section-header mt1">
              <span className="prodred-special-text">Enhance Design</span> And
              Testing Phases
            </p>
            <p className="prodred-section-text">{PROD_RED.ENHANCE_DESIGN}</p>
          </Col>
          <Col lg={12} className="flex-center">
            <img
              src={enhanceDesign}
              className="prodred-image"
              alt="enhance design"
            />
          </Col>
        </Row>
        <Row className="prod-red-benefits pr4 pl4 pb2 pt2 prodred-main-benefits">
          <Col lg={24}>
            <Row justify="space-around mb2">
              <Col className="prod-red-benefits-header">
                <span className="prod-red-benefits-text1">ProdRed</span>
                <span className="prod-red-benefits-text2">Benefits</span>
              </Col>
            </Row>
            <Row justify="space-around">
              <Col className="prodred-section-text benefits-text">
                {PROD_RED.PRODRED_BENEFITS_TEXT}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row
          className="prodred-section pr4 pl4 pb2 pt2 prodred-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <p className="prodred-section-header mt1">
              Vehicle
              <span className="prodred-special-text"> Testing Analytics</span>
            </p>
            <p className="prodred-section-text">{PROD_RED.VEHICLE_ANALYTICS}</p>
            <p className="prodred-section-sub-header">
              {PROD_RED.VEHICLE_ANALYTICS_1}
            </p>
            {[
              PROD_RED.VEHICLE_ANALYTICS_1_1,
              PROD_RED.VEHICLE_ANALYTICS_1_2,
              PROD_RED.VEHICLE_ANALYTICS_1_3,
              PROD_RED.VEHICLE_ANALYTICS_1_4,
            ].map((item, index) => (
              <div key={index} className="prodred-check-icons">
                <p>
                  <span className="check-circle-filled">
                    <CheckCircleFilled />
                  </span>
                  {item}
                </p>
              </div>
            ))}
          </Col>
          <Col
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
            className="flex-center"
          >
            <img
              src={vehicleTestingAnalytics}
              className="prodred-image"
              alt="vehicle analytics"
            />
          </Col>
        </Row>
        <Row
          className="pr4 pl4 pb2 pt2 prodred-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={12}>
            <p className="prodred-section-header mt1">
              <span className="prodred-special-text">Test Ride </span>Analytics
            </p>
            <p className="prodred-section-text">{PROD_RED.TEST_ANALYTICS}</p>
            {[
              PROD_RED.TEST_ANALYTICS_1,
              PROD_RED.TEST_ANALYTICS_2,
              PROD_RED.TEST_ANALYTICS_3,
              PROD_RED.TEST_ANALYTICS_4,
            ].map((item, index) => (
              <div key={index} className="prodred-check-icons">
                <p>
                  <span className="check-circle-filled">
                    <CheckCircleFilled />
                  </span>
                  {item}
                </p>
              </div>
            ))}
          </Col>
          <Col lg={12} className="flex-center">
            <img
              src={testRideAnalytics}
              className="prodred-image"
              alt="test ride analytics"
            />
          </Col>
        </Row>
        <Row
          className="prodred-section pr4 pl4 pt2 pb4 prodred-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <p className="prodred-section-header mt1">
              <span className="prodred-special-text">End of Line </span>
              Testing
            </p>
            <p className="prodred-section-text">{PROD_RED.END_LINE_TESTING}</p>
            <p className="prodred-section-sub-header">
              {PROD_RED.END_LINE_TESTING_1}
            </p>
            {[
              PROD_RED.END_LINE_TESTING_1_1,
              PROD_RED.END_LINE_TESTING_1_2,
              PROD_RED.END_LINE_TESTING_1_3,
              PROD_RED.END_LINE_TESTING_1_4,
            ].map((item, index) => (
              <div key={index} className="prodred-check-icons">
                <p>
                  <span className="check-circle-filled">
                    <CheckCircleFilled />
                  </span>
                  {item}
                </p>
              </div>
            ))}
          </Col>
          <Col
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
            className="flex-center"
          >
            <img
              src={endLineTesting}
              className="prodred-image"
              alt="test ride analytics"
            />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default ProdRed;
